import type normalize from 'json-api-normalizer'

/**
 * json-api-normalizer, loaded on first use: it pulls core-js modules and is only needed by the
 * Spree/academy flows, so it stays out of the shared _app bundle (Cuidei landings, PageSpeed).
 */
export const normalizeJsonApi = async (
  data: Parameters<typeof normalize>[0]
): Promise<ReturnType<typeof normalize>> => {
  const { default: normalizeData } = await import('json-api-normalizer')
  return normalizeData(data)
}
